export default "__VITE_ASSET__D0Z6ehiu__"